<template>
  <div v-if="warnings.length || (displayErrors && errors.length)" class="warnings">
    <p v-if="title" class="title">
      {{ title }}
    </p>

    <ul class="warnings-list">
      <li v-for="(warning, index) of warnings" :key="`warning_${index}`" class="warning">
        <span v-html="warning" />
      </li>
      <template v-if="displayErrors">
        <li v-for="(error, index) of errors" :key="`error_${index}`" class="warning">
          <span v-html="error" />
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
// Wyświetla warningi
export default {
  props: {
    // Schema z warningami
    model: { type: Object, required: true },
    // Tytuł
    title: { type: String, required: false },
    // Czy wyświetlać również błędy
    displayErrors: { type: Boolean, default: false }
  },
  computed: {
    warnings() {
      return this.model
        .$checkAll()
        .filter(field => field.$warnings && field.$warnings.length)
        .map(field => field.$warnings.map(warning => `${this.prepareFieldTitle(field)} ${this.removePrefix(warning)}`))
        .reduce((a, b) => a.concat(b), []);
    },
    errors() {
      return this.model
        .$validateAll()
        .map(field => `${this.prepareFieldTitle(field)} ${this.removePrefix(field.$error)}`);
    }
  },
  methods: {
    // Usuwa informację o typie komunikatu (błąd, uwaga)
    removePrefix(text) {
      const errorRegex = /^Błąd: /i;
      const warningRegex = /^Uwaga: /i;
      return text.replace(errorRegex, '').replace(warningRegex, '');
    },

    // Przygotowuje tytuł pola, wraz z dwukropkiem
    prepareFieldTitle(field) {
      const title = (field.$shortTitle || field.path).trim();
      return title.endsWith(':') ? title : `${title}:`;
    }
  }
};
</script>

<style>
.warnings .warning {
  color: #856522;
}

.warnings .title {
  font-weight: bold;
}
</style>
